/*
 * Article custom — FAQ accordion (article.blog_cust template only).
 * Progressive enhancement: turns each FAQ question (<h3>) + its answer nodes,
 * which follow an <h2 class="art-faq-heading">, into a native <details>/<summary>
 * accordion. Works on the parsed DOM, so author wrapper <div>s or content after
 * the FAQ never break it. Without JS the FAQ still reads as headings + paragraphs.
 * The FAQPage JSON-LD is rendered server-side, independent of this script.
 */
(function () {
  function enhance(heading) {
    var node = heading.nextElementSibling;
    while (node && node.tagName === 'H3') {
      var details = document.createElement('details');
      details.className = 'cc-item'; // shared FAQ style (comforsyco-faq.css)

      var summary = document.createElement('summary');
      summary.className = 'cc-q';
      summary.textContent = node.textContent.trim();

      var answer = document.createElement('div');
      answer.className = 'cc-a rte';

      // collect the answer nodes (everything until the next H3 / H2 / end)
      var next = node.nextElementSibling;
      var move = [];
      while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
        move.push(next);
        next = next.nextElementSibling;
      }

      details.appendChild(summary);
      move.forEach(function (n) { answer.appendChild(n); }); // moves nodes into answer
      details.appendChild(answer);

      node.replaceWith(details); // swap the <h3> for the <details>
      node = next; // continue from the next question (or stop)
    }
  }

  function run() {
    var headings = document.querySelectorAll('.art-faq-heading');
    for (var i = 0; i < headings.length; i++) enhance(headings[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
